<template>
  <div class="box box-shadow-none convex mb-0">
    <div class="is-flex is-justify-content-center">
      <span class="tag is-black">補助事業</span>
      <span class="has-text-theme-green title is-5 px-3">2022年度 『木とふれあう木育推進事業』今年度の申請期間は終了となりました。</span>
    </div>
    <p class="has-text-centered mt-4 p-4 lh-4_3">
      大阪府内の子育て施設様限定の補助事業をご案内！<br>
      東野材木店は補助事業の活用をサポートさせて頂きます。まずは経験豊富な私たちにご相談くださいませ。<br>
      <span class="has-text-weight-bold under-line">※2016年度〜2021年度までに大阪府補助事業で64件サポートさせて頂きました。</span>
    </p>
  </div>
  
  <div class="columns is-gapless pt-6" :class="((index % 2) === 1) ? 'is-flex-direction-row-reverse': ''" v-for="(item, index) in CONTENTS" :key="index">
    <div class="column">
      <figure class="image">
        <img class="object-fit-contain" :src="item.src" :alt="item.alt">
      </figure>
    </div>
    <div class="column has-background-theme-grey">
      <div class="content px-6 p-6-mobile">
        <p class="has-text-theme-green is-size-7 has-text-weight-bold mb-2">{{item.caption}}</p>
        <p class="title is-3 lh-6" v-html="item.title"></p>
        <p class="title is-5 lh-5" v-html="item.subtitle"></p>
        <p class="is-size-6 lh-5" v-html="item.text"></p>
      </div>
    </div>
  </div>
</template>

<script>
//import config from './../config.json';
const CONTENTS = [
  {
    "src": "./static_img/img01-01.jpg",
    "alt": "私たちの願い",
    "caption": "私たちの願い",
    "title": "大阪で育った木を選び、保育環境で活用しませんか。",
    "subtitle": "木材の販売からスタートして45年。",
    "text": "地元で育った”ほんものの木”をお届けしてきました。<br>「一園でも多くの子育て施設さまで地元で育った木」をお届けすることが私たちの願いです。",
  }
];

export default {
  name: 'parts-about-circumstance',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    CONTENTS() {
      return CONTENTS;
    }
  }
}
</script>

<style scoped>
.convex {
  margin-top:-14rem;
}

.under-line {
  background: linear-gradient(transparent 60%,#faffaf 0);
}

@media all and (min-width: 1024px) and (max-width: 1280px) {
}
 
@media all and (min-width: 768px) and (max-width: 1024px) {
} 
@media all and (min-width: 480px) and (max-width: 768px) {
  .convex {
    margin-top: inherit;
  }
}
 
@media all and (max-width: 480px) {
  .convex {
    margin-top: inherit;
  }
}
</style>
